import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import EditComponent from '../tsx/PalettesField';

export class PalettesField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = PalettesField.getDefaultValue();
        }

        super(glob, title, PalettesField.defaultValidators, validators, defaultVal, options);
    }
}
